import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative h-[90vh] min-h-[600px] flex items-center" data-testid="hero-section">
      {/* Background Image - AI Generated Calgary Basement */}
      <div className="absolute inset-0">
        <img
          src="/hero-basement.png"
          alt="Calgary basement renovation with electric fireplace and modern living space - Basement finishing Calgary"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full">
        <div className="max-w-3xl">
          <p className="text-[#c5a059] text-sm uppercase tracking-[0.3em] mb-4 animate-fade-in-up">
            Calgary's Trusted Renovation Experts
          </p>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-6 animate-fade-in-up animation-delay-200">
            Calgary Basement Renovation Built to Last
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed animate-fade-in-up animation-delay-400 font-light">
            High-quality basement and bathroom renovations designed for real Calgary homes and real families.
            <span className="block mt-2 text-[#c5a059] font-medium">Built Right. Built to Last.</span>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-600">
            <Link
              to="/contact"
              className="group inline-flex items-center justify-center gap-3 bg-[#c5a059] text-[#0f172a] px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-white transition-all duration-300"
              data-testid="hero-cta-primary"
            >
              Request Free Estimate
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="tel:403-402-6596"
              className="group inline-flex items-center justify-center gap-3 border-2 border-white text-white px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-white hover:text-[#0f172a] transition-all duration-300"
              data-testid="hero-cta-secondary"
            >
              <Phone size={18} />
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
